import { Component, inject } from '@angular/core';

import { EmbedMicroappDirective, IconComponent } from '@shared/public-api';

import { HealthSystemService } from '../../services/health-system.service';

@Component({
  selector: 'wu-health-system-modal',
  imports: [EmbedMicroappDirective, IconComponent],
  templateUrl: './health-system-modal.component.html',

  styleUrl: './health-system-modal.component.scss',
})
export class HealthSystemModalComponent {
  readonly healthSystem = inject(HealthSystemService);
}
